export const Context = {
    "unit": "Easy Systems",
    "environment": "esdev",
    "cleanEnv": "dev",
    "baseUrl": "https://dev.gateway.easysystems-cloud.com",
    "appUrl": "https://appdev.gateway.easysystems-cloud.com/",
    "ssoUrl": "",
    "apikey": "",
    "region": "eu-west-1",
    "buckedPrefix": "apigateway"
}